import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { CostReceiverService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CostReceiverCreateDto,
  CostReceiverDto,
  CostReceiverExcelDownloadDto,
  CostReceiverUpdateDto,
} from '../proxy/controlling/dtos/cost-receiver';
import { COSTRECEIVER_CONFIG, COSTRECEIVER_FIELDS } from './cost-receiver.config';
import { BaseCrudComponent, CrudPage, EntityConfig, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-cost-receiver',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CostReceiverService, ConfirmationService],
  templateUrl: './cost-receiver.html',
  styleUrl: './cost-receiver.scss',
})
export class CostReceiver extends BaseCrudComponent<
  CostReceiverDto,
  CostReceiverCreateDto,
  CostReceiverUpdateDto,
  CostReceiverExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(CostReceiverService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('CostReceiver', ids),
  };
  config = {
    ...COSTRECEIVER_CONFIG,
    permission: 'ControllingLiquidations.CostReceivers.DisabledActions',
  }
  fields = COSTRECEIVER_FIELDS;

  protected prepareUpdateDto(data: any, selected: CostReceiverDto): CostReceiverUpdateDto {
    return {
      name: data.name,
      isActive: data.isActive,
      cycle: data.cycle,
      cycleRotation: data.cycleRotation,
      costReceiverTypeId: data.costReceiverTypeId,
      entityId: data.entityId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CostReceiver';
  }
}
